import _ from 'lodash'

import { SET_SORT_ORDER } from '../actions/applySortOrder'

const initialState = ''

export default function sorting(state = initialState, action) {
  switch (action.type) {
    case SET_SORT_ORDER:
      return action.payload
    default:
      return state
  }
}

export const getSortOrder = state => _.get(state, 'sortingData')
